import { UsersThree } from "@phosphor-icons/react";

import RenderIf from "common/components/RenderIf";
import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";
import { formatNumber } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";

import type React from "react";

interface SearchParamsProps {
  totalCount: number;
  isLoadingProfiles: boolean;
  resetSearchParamsButton: React.ReactNode;
}

export default function SearchParams({
  totalCount,
  isLoadingProfiles,
  resetSearchParamsButton,
}: SearchParamsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const totalCountComponent = isLoadingProfiles ? (
    <Skeleton className="h-7 w-20 max-lg:self-end lg:mt-[29px]" />
  ) : (
    <RenderIf condition={!!totalCount}>
      <Tag
        className="max-lg:self-end lg:mt-[29px]"
        variant="secondary"
        size="lg"
        leftIcon={<UsersThree weight="fill" />}
      >
        {formatNumber(totalCount)}
      </Tag>
    </RenderIf>
  );

  if (isDesktop)
    return (
      <DesktopLayout
        totalCountComponent={totalCountComponent}
        resetSearchParamsButton={resetSearchParamsButton}
      />
    );

  return (
    <>
      <MobileLayout />
      {totalCountComponent}
    </>
  );
}
